import { useState } from 'react'
import { useRouter } from 'next/router'
import { REMOVE_PRODUCTS_FROM_WISHLIST } from '../graphql/removeProductsFromWishlist'
import { graphqlFetch, GraphqlFetchOutput } from '@pylot-data/graphqlFetch'
import { useWishlist } from './use-wishlist'
import {
    MutationRemoveProductsFromWishlistArgs,
    RemoveProductsFromWishlistOutput
} from '@pylot-data/pylotschema'

export interface OutputInterface {
    removeProductsFromWishlist: RemoveProductsFromWishlistOutput
}

export interface UseRemoveProductsFromWishlistInterface {
    isLoading: boolean
    removeProductsFromWishlist: (
        formInput: MutationRemoveProductsFromWishlistArgs
    ) => Promise<GraphqlFetchOutput<OutputInterface>>
}

export const useRemoveProductsFromWishlist = (): UseRemoveProductsFromWishlistInterface => {
    const [isLoading, setIsLoading] = useState(false)
    const { locale } = useRouter()
    const { mutate } = useWishlist()

    const removeProductsFromWishlist = async (
        formInput: MutationRemoveProductsFromWishlistArgs
    ) => {
        setIsLoading(true)

        const response = await graphqlFetch<
            MutationRemoveProductsFromWishlistArgs,
            OutputInterface
        >({
            query: REMOVE_PRODUCTS_FROM_WISHLIST,
            variables: formInput,
            locale
        })

        await mutate()
        setIsLoading(false)

        return response
    }

    return {
        isLoading,
        removeProductsFromWishlist
    }
}
